<template>
  <v-container>
    <v-card elevation="2">
      <v-card-title> Goals </v-card-title>
      <v-tabs v-model="tab" color="secondary" fixed-tabs>
        <v-tabs-slider color="secondary"></v-tabs-slider>
        <!-- <v-tab key="checkin"
          >Check-in
          <v-icon v-if="checkinGoals.length == 0" color="red">mdi-alert-circle-outline</v-icon>
        </v-tab> -->
        <v-tab key="bhag"
          >Coaching Goals
          <v-icon v-if="bhagGoals.length == 0" color="red">mdi-alert-circle-outline</v-icon>
        </v-tab>
        <v-tab key="webApp">App</v-tab>
        <v-tab v-if="userGoals.ticketGoal" key="old">1-on-1 (old)</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <!-- <v-tab-item key="checkin">
          <div v-if="checkinGoals.length > 0">
            <v-card v-for="goal in checkinGoals" :key="goal.id">
              <goal :goal="goal"></goal>
            </v-card>
          </div>
          <v-card v-else>
            <v-card-text> No check-in goal set. </v-card-text>
          </v-card>
        </v-tab-item> -->
        <v-tab-item key="bhag">
          <div v-if="bhagGoals.length > 0">
            <v-card v-for="goal in bhagGoals" :key="goal.id">
              <goal :goal="goal" class="mb-4 mt-2"></goal>
            </v-card>
          </div>
          <v-card v-else>
            <v-card-text> No coaching goal set.</v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item key="webApp">
          <v-simple-table v-if="userGoals.webappGoal">
            <tbody>
              <tr>
                <td>Primary Goal</td>
                <td>{{ userGoals.webappGoal.primaryGoal }}</td>
              </tr>
              <tr>
                <td>Level</td>
                <td>{{ userGoals.webappGoal.secondaryGoal }}</td>
              </tr>
              <tr>
                <td>Comments</td>
                <td>{{ userGoals.webappGoal.comments }}</td>
              </tr>
            </tbody>
          </v-simple-table>
          <v-card-text v-else> No web app goal found for user. </v-card-text>
        </v-tab-item>
        <v-tab-item key="old">
          <v-simple-table v-if="userGoals.ticketGoal">
            <tbody>
              <tr>
                <td>Weight</td>
                <td>{{ userGoals.ticketGoal.weight }}</td>
              </tr>
              <tr>
                <td>Smart Goal</td>
                <td>{{ userGoals.ticketGoal.smartGoal }}</td>
              </tr>
              <tr>
                <td>Description</td>
                <td>{{ userGoals.ticketGoal.ultimateWhy }}</td>
              </tr>
              <tr>
                <td>Running Distance</td>
                <td>{{ userGoals.ticketGoal.runningDistanceInKm }}</td>
              </tr>
            </tbody>
          </v-simple-table>
          <v-card-text v-else> No primary goal found for user. </v-card-text>
        </v-tab-item>
      </v-tabs-items>
      <v-card-actions>
        <v-spacer />
        <v-btn :href="viewAllAssessmentsLink">
          View all goals
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import { CLIENT_GOALS_QUERY, USER_GOALS_QUERY } from "@/constants/graphql/goal/goal";
import Goal from "../blocks/progress/assessments/goals/Goal";

export default {
  name: "ClientGoals",
  props: ["userId", "coachId"],
  components: {
    Goal,
  },
  data() {
    return {
      loading: true,
      tab: null,
      userGoals: {
        ticketGoal: null,
        webappGoal: null,
      },
      checkinGoals: [],
      bhagGoals: [],
    };
  },
  computed: {
    viewAllAssessmentsLink() {
      if (this.coachId) return `/client-profile/${this.coachId}/${this.userId}/assessments?goals=1`;
      else return `/client-profile/${this.userId}/assessments?goals=1`;
    },
  },
  apollo: {
    userGoals: {
      query: USER_GOALS_QUERY,
      variables() {
        return {
          userId: this.userId,
        };
      },
      fetchPolicy: "cache-and-network",
      result(response) {
        if (response.data) {
          this.loading = false;
        }
      },
    },
    clientGoals: {
      query: CLIENT_GOALS_QUERY,
      variables() {
        return {
          userId: this.userId,
          //active: true,
        };
      },
      fetchPolicy: "cache-and-network",
      update(data) {
        // this.checkinGoals = data.clientGoals.filter((goal) => goal.timeframe != "BHAG");
        // this.bhagGoals = data.clientGoals.filter((goal) => goal.timeframe == "BHAG");

        this.bhagGoals = data.clientGoals;
        return data.clientGoals;
      },
    },
  },
};
</script>

<style scoped></style>
